<template>
  <div v-if="msgs.length > 0" class="warningmsg">
    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
    <p v-if="msgs.length > 1">
      {{ $t("errors.selectp", {formatedErrors: formatedMsgs}) }}
    </p>
    <p v-if="msgs.length == 1">
      {{ $t("errors.select", {formatedErrors: formatedMsgs}) }}
    </p>
  </div>
  <div v-if="errors.length > 0" class="errormsg">
    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
    <p v-if="errors.length > 1">
      {{ $t("errors.obrigatorios", {formatedErrors: formatedErrors}) }}</p>
    <p v-if="errors.length == 1">
      {{ $t("errors.obrigatorio", {formatedErrors: formatedErrors}) }}    
    </p>
  </div>
</template>

<script>
export default {
  name: 'ErrorForms',
  props: ["errors","msgs"],
  computed: {
    formatedErrors(){
      if (this.errors.length > 1) {
        const quotedErrors = this.errors.map(error => `"${error}"`);
        return quotedErrors.slice(0, -1).join(', ') + ' e ' + quotedErrors.slice(-1);
      } else {
        return `"${this.errors[0]}"`;
      }
    },
    formatedMsgs(){
      if (this.msgs.length > 1) {
        const quotedMsgs = this.msgs.map(msg => `"${msg}"`);
        return quotedMsgs.slice(0, -1).join(', ') + ' e ' + quotedMsgs.slice(-1);
      } else {
        return `"${this.msgs[0]}"`;
      }  
    }
  }
}
</script>

<style scoped>
.warningmsg{
  padding-top: 9px;
  padding-bottom: 9px;
  padding-left: 20px;
  background-color: #faf4da;
  border-radius: 8px;
  margin-left: 80px;
  display: flex;
}

.errormsg {
  padding-top: 9px;
  padding-bottom: 9px;
  padding-left: 20px;
  background-color: #faf4da;
  border-radius: 8px;
  margin-left: 80px;
  display: flex;
}

.warningmsg p {
  line-height: 20.2px;
  padding-bottom: 10px;
  padding-right: 15px;
}

.errormsg p {
  line-height: 20.2px;
  padding-bottom: 10px;
  padding-right: 15px;
}

@media only screen and (max-width:1450px) {

  .warningmsg {
    margin-left: 0px;
    margin-top: 30px;
  }

  .errormsg {
    margin-left: 0px;
    margin-top: 30px;
  }

}

@media screen and (min-device-width : 768px) 
and (max-device-width : 1024px)   {
  .warningmsg{
    margin-left: 0;
    margin-top: 15px;
    margin-bottom: 15px;
  } 

  .errormsg{
    margin-left: 0;
    margin-top: 15px;
    margin-bottom: 15px;
  }  
}

.warningmsg i{
  color: #f1c74b;
  margin-right: 8px;
  font-size: 20px;
}

.errormsg i{
  color: #e43838;
  margin-right: 8px;
  font-size: 20px;
}

.errormsg{
  padding-top: 9px;
  padding-bottom: 9px;
  padding-left: 20px;
  background-color: #fbe5e4;
  border-radius: 8px;
  margin-top: 6px;
  display: flex;
}


.errormsg p, .warningmsg p{
  font-family: "Montserrat";
  font-size: 15px;
  margin-bottom: 0;
}

@media screen and (max-device-width : 768px) {
  .errormsg p, .warningmsg p{
    font-size: 12px;
  }
}

</style>